import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import Wrapper from "../../../common/Wrapper";
import Header from "../../../common/Header";
import NotificationBar from "../../../Parts/NotificationBar.jsx";
import SalesforceUnSetting from "../common/SalesforceUnSetting";
import SalesforceNotSupport from "../common/SalesforceNotSupport";
import SalesforceNotAuthorize from "../common/SalesforceNotAuthorize";
import SalesforceIntegrateExpire from "../common/SalesforceIntegrateExpire";
import SalesforceIntegrateOverview from "../common/SalesforceIntegrateOverview";
import SalesforceIntegrateLoading from "../common/SalesforceIntegrateLoading";
import SalesforceIntegrateResult from "../common/SalesforceIntegrateResult";
import TimelineStatusMappingTable from "./parts/TimelineStatusMappingTable";
import {
  SalesforceSettingDirectory,
  SalesforceExportMappingFrom,
  SalesforceTimelineStatusExportObjectType,
} from "../../../../constants/ComponentTypes";
import { makeSalesforceExportMap } from "../../../../utils/utils";

const { Map } = require("immutable");

const styles = () => ({
  root: {
    width: "100%",
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    flexWrap: "nowrap",
    alignItems: "flex-start",
  },

  content: {
    background: "#F4F6F9",
    flex: 1,
    width: "100%",
    position: "relative",
    overflow: "scroll",
  },
});

/**
 * タイムラインのSalesforce連携設定詳細画面
 */
class SalesforceTimelineStatusSetting extends React.Component {
  state = {
    showNotification: false,
    message: "",
    messageType: "success",
    mapping: Map(),
  };

  componentDidMount() {
    this.props.getUserInfo();
    this.props.getSalesforceDescribeTimelineStatusExport();
    this.props.getSalesforceExportMappings({ type: SalesforceExportMappingFrom.TIMELINE_STATUS.value });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.successMessage === this.props.successMessage && this.props.successMessage && this.props.successMessage !== "") {
      this.displayNotification(this.props.successMessage, "success");
    } else if (prevProps.errorMessage !== this.props.errorMessage && this.props.errorMessage && this.props.errorMessage !== '') {
      this.displayNotification(this.props.errorMessage, "error");
    } else if (prevProps.shortMessage !== this.props.shortMessage && this.props.shortMessage && this.props.shortMessage !== '') {
      this.displayNotification(this.props.shortMessage, "green");
    }

    // DBの値に上書きする
    if (prevProps.isLoadingMapping && !this.props.isLoadingMapping) {
      this.setState({
        mapping: makeSalesforceExportMap(this.props.mapping),
      });
    }
  }

  displayNotification = (message, type) => {
    this.setState({
      showNotification: true,
      message: message,
      messageType: type,
    });
  };

  /*** handlers ***/
  goToSalesforceSettingHome = () => {
    this.props.goTo("/setting/integrations/salesforce");
  }

  /*** render functions ***/
  renderNotification = () => {
    if (this.state.showNotification) {
      return (
        <div
          style={{
            position: "fixed",
            zIndex: 10000,
            top: 10,
            width: "98%",
            left: "1%",
          }}
        >
          <NotificationBar
            message={this.state.message}
            type={this.state.messageType}
            open={this.state.showNotification}
            onHandleClose={() => {
              this.setState({ showNotification: false });
            }}
            autoClose={false}
            style={{
              width: this.state.messageType === "green" ? "fit-content" : "100%",
            }}
          ></NotificationBar>
        </div>
      );
    }
  };

  render() {
    const { classes, isLoadingMapping, isLoadingFields } = this.props;

    return (
      <Wrapper className={classes.root}>
        <Header
          title="Salesforce連携設定"
          secondaryTitle={SalesforceSettingDirectory.TIMELINE_STATUS.text + "連携設定"}
          type="dark"
          hasBackBtn={false}
          onTitleClicked={this.goToSalesforceSettingHome}
        />
        <div className={classes.content}>
          {(() => {
            if (this.props.user) {
              return (
                <SalesforceIntegrateOverview tabValue={SalesforceSettingDirectory.TIMELINE_STATUS.value}>
                  {(() => {
                    if (!this.props.user.salesforce_integration_flag) {
                      return <SalesforceNotSupport />;
                    } else if (!this.props.user.integrations.salesforce) {
                      return <SalesforceNotAuthorize />;
                    } else if (this.props.expiredAccessError) {
                      return <SalesforceIntegrateExpire />;
                    } else if (isLoadingMapping || isLoadingFields) {
                      return <SalesforceIntegrateLoading />;
                    } else if (Object.keys(this.props.mapping).length === 0) {
                      return <SalesforceUnSetting salesforceSettingDirectory={SalesforceSettingDirectory.TIMELINE_STATUS} />;
                    } else {
                      return (
                        <SalesforceIntegrateResult
                          salesforceSettingDirectory={SalesforceSettingDirectory.TIMELINE_STATUS}
                          sobjectName={SalesforceTimelineStatusExportObjectType.EVENT.text}
                        >
                          <TimelineStatusMappingTable
                            mapping={this.state.mapping}
                            enableEdit={false}
                            disabled={false}
                            eventFields={this.props.eventFields}
                          />
                        </ SalesforceIntegrateResult>
                      );
                    }
                  })()}
                </SalesforceIntegrateOverview>
              );
            }
          })()}
        </div>
        {this.renderNotification()}
      </Wrapper>
    );
  }
}

SalesforceTimelineStatusSetting.propTypes = {
  classes: PropTypes.object.isRequired,
  user: PropTypes.object,
  successMessage: PropTypes.string,
  errorMessage: PropTypes.string,
  shortMessage: PropTypes.string,
  isLoadingMapping: PropTypes.bool.isRequired,
  isLoadingFields: PropTypes.bool.isRequired,
  expiredAccessError: PropTypes.bool.isRequired,
  mapping: PropTypes.object,
  eventFields: PropTypes.object,
  goTo: PropTypes.func.isRequired,
  getUserInfo: PropTypes.func.isRequired,
  getSalesforceDescribeTimelineStatusExport: PropTypes.func.isRequired,
  getSalesforceExportMappings: PropTypes.func.isRequired,
};

export default withStyles(styles)(SalesforceTimelineStatusSetting);



// WEBPACK FOOTER //
// ./src/components/AccountSetting/Salesforce/SalesforceTimelineStatusSetting/SalesforceTimelineStatusSetting.jsx